import { KTSVG, showNotification } from '@ospace/shared'
import { useState } from 'react'
import { Button, Menu, Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useMutation } from 'react-query'
import { Link } from 'react-router-dom'

const SimpleLink = (props: any) => {
  const { item, index } = props
  return (
    <Menu.Item className='px-3 py-2' component={Link} to={item.link} key={index}>
      <span className='text-dark fw-bold text-capitalize menu-link'>{item.name}</span>
    </Menu.Item>
  )
}

const ActionLink = (props: any) => {
  const { item, index, toggleShow } = props
  const [opened, { open, close }] = useDisclosure(false)

  const mutation = useMutation(
    () => {
      return item.action.call(null, item.params.id)
    },
    {
      onSuccess: () => {
        showNotification({
          message: item.successMessage,
          type: 'success',
        })
        item.callback()
        toggleShow(false)
      },
      onError: (e: any) => {
        showNotification({
          message: e.message,
          type: 'error',
        })
      },
    }
  )

  const onClickHanlder = () => {
    toggleShow(false)
    open()
  }

  const handleClose = () => {
    close()
  }

  const handleContinue = () => {
    close()
    mutation.mutate()
  }

  return (
    <>
      {item.alertMessage && (
        <Modal opened={opened} onClose={close} withCloseButton={false} centered padding='lg'>
          <Modal.Body>{item.alertMessage}</Modal.Body>
          <div className='d-flex justify-content-end gap-2 mt-10'>
            <Button size='sm' variant='secondary' onClick={handleClose}>
              Cancel
            </Button>
            <Button size='sm' variant='primary' onClick={handleContinue}>
              Proceed
            </Button>
          </div>
        </Modal>
      )}
      <Menu.Item className='px-3 py-2' key={index} onClick={onClickHanlder}>
        {mutation.isLoading && (
          <span className='spinner-border spinner-border-sm align-middle mx-2' />
        )}
        <span className='text-dark fw-bold text-capitalize menu-link'>{item.name}</span>
      </Menu.Item>
    </>
  )
}

const CDropdown = (props: any) => {
  const { items } = props
  const [show, toggleShow] = useState(false)

  const dropdownToggle = () => {
    toggleShow(!show)
  }

  return (
    <Menu opened={show} onChange={toggleShow} withinPortal={false} position='bottom-end'>
      <Menu.Target>
        <button
          type='button'
          className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary hover showing p-5'
          onClick={dropdownToggle}
        >
          <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
        </button>
      </Menu.Target>
      <Menu.Dropdown className='px-1 w-200px'>
        {items.map((item: any, index: number) =>
          item.link ? (
            <SimpleLink item={item} index={index} key={index} />
          ) : (
            <ActionLink item={item} index={index} key={index} toggleShow={toggleShow} />
          )
        )}
      </Menu.Dropdown>
    </Menu>
  )
}
export default CDropdown
